import TableWithLoadingWrapper from '../../../../components/generic/dataGrid'
import SearchBar from '../../bankAccountsAll/tempComponents/searchBar'
import HeaderBox from '../../../../components/generic/arpariBoxes/headerBox'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useReducer, useEffect, useCallback } from 'react'
import { errorMessage } from '../../../../helpers/errorMessageFunc'
import { backendGetRequest } from '../../../../helpers/callBackend'
import theme from '../../../../helpers/theme'
import { Link } from 'react-router-dom'
import CustomReportsTableDropDown from '../../../../components/specific/reports-custom/CustomReportsTableDropDown'

const reducer = (state, action) => {
  switch (action.type) {
    default:
      return state
    case 'GET_START':
      return {
        ...state,
        loading: true,
        totalRecords: action.payload || 0,
      }
    case 'GET_SUCCESS':
      const loadingDone =
        state.totalRecords >= 0 && state.tableData.length + action.payload.length >= state.totalRecords
      return {
        ...state,
        loading: !loadingDone,
        tableData: [...state.tableData, ...action.payload],
        displayData: [...state.displayData, ...action.payload],
      }
    case 'SEARCH':
      return {
        ...state,
        displayData: action.payload,
      }
    case 'DELETE':
      const filteredTableData = state.tableData.filter((row) => row.id !== action.payload.id)
      const filteredDisplayData = state.displayData.filter((row) => row.id !== action.payload.id)
      return {
        ...state,
        tableData: filteredTableData,
        displayData: filteredDisplayData,
      }
  }
}

const getPage = async (pageNum, dispatch) => {
  try {
    const pageResp = await backendGetRequest('/api/reports/v2', {
      params: {
        page_index: pageNum,
        serializer: 'group_details',
      },
    })
    const respData = pageResp.data?.data
    if (!respData) {
      throw new Error('No page data returned')
    }
    dispatch({
      type: 'GET_SUCCESS',
      payload: respData,
    })
  } catch (error) {
    errorMessage(error.message)
  }
}

const getData = async (dispatch) => {
  try {
    const pageInfo = await backendGetRequest('/api/reports/v2', {
      params: {
        page_index: 0,
      },
    })
    const totalPages = pageInfo.data?.total_pages
    const totalRecords = pageInfo.data?.total_records
    if (!totalPages && totalPages !== 0) {
      throw new Error('No page information returned')
    }
    dispatch({
      type: 'GET_START',
      payload: totalRecords,
    })
    if (totalPages > 0) {
      for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
        getPage(pageNum, dispatch)
      }
    }
  } catch (error) {
    errorMessage(error.message)
  }
}

// hoisted action creator functions
const deleteAction = (row) => {
  return {
    type: 'DELETE',
    payload: row,
  }
}

const searchAction = (rows) => {
  return {
    type: 'SEARCH',
    payload: rows,
  }
}

const ReportsCustomPage = () => {
  const initialState = {
    tableData: [],
    displayData: [],
    totalRecords: -1,
    loading: true,
  }
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    getData(dispatch)
  }, [getData])

  const handleDelete = useCallback(
    (row) => {
      dispatch(deleteAction(row))
    },
    [dispatch]
  )

  const handleSearch = useCallback(
    (rows) => {
      dispatch(searchAction(rows))
    },
    [dispatch]
  )

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      renderCell: (params) => {
        const { id, name } = params.row
        return <Link to={`/reports-custom/details/000${id}`}>{name}</Link>
      },
    },
    {
      field: 'grouping',
      headerName: 'Account Grouping',
      flex: 1,
      renderCell: (params) => {
        const { group_name, report_type } = params.row
        return (
          <Stack spacing={1} direction='row' height='100%' alignItems='center'>
            <Typography sx={{ fontSize: '1rem' }} color='secondary'>
              {report_type}
            </Typography>
            <Typography>{group_name}</Typography>
          </Stack>
        )
      },
    },
    {
      field: 'dropdown',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        return (
          <CustomReportsTableDropDown
            rowData={params.row}
            onDelete={(row) => {
              handleDelete(row)
            }}
          />
        )
      },
    },
  ]

  return (
    <Box sx={{ maxHeight: '99%', overflow: 'auto' }}>
      <Box sx={{ margin: theme.dashboard.margins }}>
        <Stack spacing={1}>
          <HeaderBox
            title='Custom Reports'
            actions={
              <Button
                href='/reports-custom/editing/details/new'
                disableElevation
                size='small'
                variant='contained'
                sx={{ fontSize: 14, textTransform: 'none' }}
              >
                + Add New
              </Button>
            }
          />
          <SearchBar
            originalTableData={state.tableData}
            searchKeys={[['name']]}
            isLoading={state.loading}
            setSearchText={() => {}}
            updateTableState={(newData) => {
              handleSearch(newData)
            }}
          />
          <TableWithLoadingWrapper
            loading={state.loading}
            pagination={{
              paginationModel: {
                pageSize: 25,
                page: 0,
              },
            }}
            pageSizeOptions={[5, 10, 25]}
            columns={columns}
            dataSource={state.displayData}
            sortModel={[
              {
                field: 'name',
                sort: 'asc',
              },
            ]}
          />
        </Stack>
      </Box>
    </Box>
  )
}

export default ReportsCustomPage
